class PerfTimer {
   static instance = null

    constructor() {
        this.start = performance.now()
    }

    static getInstance() {
        if (PerfTimer.instance === null) {
            PerfTimer.instance = new PerfTimer()
        }

        return PerfTimer.instance
    }

    print(message) {
        message = `${this.elapsed()} sec when ${message}`
        console.log(message)
    }

    restart() {
        this.start = performance.now()
    }

    elapsed() {
        const now = performance.now()
        return Math.round((now - this.start) / 1000)
    }
}

export default PerfTimer
